import React from "react";
import {Layout} from "antd";
import Header from "../components/headerComponent/header";
import Footer from "../components/footerComponent/footer";
import Analytics from "../components/financeComponent/analyticsComponent";

export default function AnalyticsPage() {
    return (
        <Layout>
            <Header/>
            <Analytics/>
            <Footer/>
        </Layout>
    );
}